export const DEFAULT_GOAL_QUANTITY = 50;
export const DEFAULT_PRODUCT_PRICE = 20;
export const MAXIMUM_PRODUCT_COUNT = 6;
export const MINIMUM_PRODUCT_PRICE = 15;
export const GOAL_QUANTITY_OPTIONS = [50, 100, 150];
export const PRINT_MINIMUM_COUNT = 7;
export const AUTOSAVE_EMAIL = 'autosave@booster.com';
export const TOO_MANY_PRODUCTS_ERROR_MESSAGE = `Your fundraiser can only have ${MAXIMUM_PRODUCT_COUNT} products.`;
export const NAMES_NUMBERS_ERROR_MESSAGE =
  "Our fundraiser system currently doesn't support name and numbers. Please remove names & numbers personalization.";
export const SUGGESTED_PRICE_MATCHERS = {
  150: 'north face|soft shell',
  125: 'columbia|down|marmot',
  75: 'adidas|eddie bauer|fleece',
  60: 'jacket',
  50: 'chair|vest|windshirt',
  45: 'coat|duffel|sweatpants',
  40: 'nike|pant|quarter|under armour|zip',
  35: 'comfort|jersey|pullover',
  30: 'blanket|bra|canvas|hooded|hoodie|jogger|performance|raglan|sweatshirt|usa',
  25: 'alternative|american|apparel|beanie|bella|camo|crewneck|district|gap|ladies|lat|level|long|melange|next|pinnie|pocket|polo|racerback|ringer|scrub|soft|style|tank|tie-dye|top|tri-blend|v-neck'
};
